import styled from "styled-components";

const Svg = styled.svg`
  .st0 {
    fill: none;
    padding-bottom: 10px;
  }

  .st1 {
    enable-backgroung: new;
    
  }

  .st2 {
    fill: #838383;
  }

`;


const DurationIcon = () => {

    return (
        <Svg xmlns="http://www.w3.org/2000/svg" className="st0" width="22"  viewBox="0 0 22 22.001" paddingBottom="10">

            {/*<rect x="0.4" y="1" className="st0" width="22" height="15.2"/>*/}
            <g className="st1">
                <path className="st2" d="M19.1,7.6c0,3.7-3,6.8-6.8,6.8c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8C16,0.8,19.1,3.8,19.1,7.6z M12.3,1.7
		C9,1.7,6.4,4.3,6.4,7.6c0,3.3,2.7,5.9,5.9,5.9c3.3,0,5.9-2.7,5.9-5.9C18.2,4.3,15.5,1.7,12.3,1.7z M11.9,8.4
		c-0.1-0.1-0.1-0.2-0.1-0.3V3.8c0-0.2,0.1-0.3,0.3-0.3h0.4c0.2,0,0.3,0.1,0.3,0.3v4l1.9,1.4c0.1,0.1,0.2,0.3,0.1,0.5l-0.2,0.3
		c-0.1,0.1-0.3,0.2-0.5,0.1L11.9,8.4z"/>
            </g>
        </Svg>

    );


}

export default DurationIcon;
